import type { MouseEventHandler } from 'react'
import type { ICard } from '../Card'

import { useState } from 'react'

export const useTvCardHoverHandlers = <
  T extends Pick<ICard, 'onMouseEnter' | 'onMouseLeave'>,
>(
  rest: T
): {
  hoverContentVisible: boolean
  cardRest: Omit<T, 'onMouseEnter' | 'onMouseLeave'>
  onMouseEnter: MouseEventHandler<HTMLDivElement>
  onMouseLeave: MouseEventHandler<HTMLDivElement>
} => {
  const [hoverContentVisible, setHoverContentVisible] = useState(false)
  const {
    onMouseEnter: onMouseEnterRest,
    onMouseLeave: onMouseLeaveRest,
    ...cardRest
  } = rest

  const onMouseEnter: MouseEventHandler<HTMLDivElement> = (event) => {
    setHoverContentVisible(true)
    onMouseEnterRest?.(event)
  }

  const onMouseLeave: MouseEventHandler<HTMLDivElement> = (event) => {
    setHoverContentVisible(false)
    onMouseLeaveRest?.(event)
  }

  return { hoverContentVisible, cardRest, onMouseEnter, onMouseLeave }
}
